import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Autocomplete, TextField, Box, Stack } from '@mui/material'
import MainCard from 'components/MainCard'
import React, { useState } from 'react'

function PaymentLogs() {
   
    const payments = [
        {
            coachId: 1,
            coachName: 'Coach - 1',
            amount: 5000,
            transationid: '45GFHVV764FHFJ0',
            paymentmode: 'Card',
            paymentDate: '05-05-2025',
            paymentstatus: 1,
        },
        {
            coachId: 2,
            coachName: 'Coach - 2',
           amount: 5000,
            transationid: 'DSFBGH74567FCVB',
            paymentmode: 'UPI',
            paymentDate: '29-04-2025',
            paymentstatus: 1,
        },
        {
            coachId: 3,
            coachName: 'Coach - 3',
            amount: 2500,
            transationid: '15GFHDFVV764F345',
            paymentmode: 'NEFT',
            paymentDate: '26-06-2025',
            paymentstatus: 0,
        },
        {
            coachId: 4,
            coachName: 'Coach - 4',
          amount: 5000,
            transationid: 'GFSDFB55V764F76',
            paymentmode: 'UPI',
            paymentDate: '13-06-2025',
            paymentstatus: 1,
        },
        {
            coachId: 5,
            coachName: 'Coach - 5',
            amount: 2500,
            transationid: 'Z45GFHHU74MZX',
            paymentmode: 'Card',
            paymentDate: '22-05-2025',
            paymentstatus: 0,
        },
    ];
   
    const [searchTerm, setSearchTerm] = useState('');

    const filteredPayments = payments.filter((payment) =>
      payment.transationid.toLowerCase().includes(searchTerm.toLowerCase())
    );

  return (
    <MainCard>
      <Stack direction="row" spacing={2} alignItems="center" mb={2}>
        <TextField
          label="Search by Transaction ID"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{ width: 300 }}
          InputLabelProps={{
            sx: {  top:'5%'}
          }}
        />
      </Stack>
      <TableContainer component={Paper}>
                <Table sx={{ minWidth: 800 }} aria-label="coach table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Coach Name</TableCell>
                      <TableCell>Amount (₹)</TableCell>
                      <TableCell>Transaction Id</TableCell>  
                      <TableCell>Transaction Mode</TableCell>
                      <TableCell>Payment Date</TableCell>                        
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>Status</TableCell>                      
                    </TableRow>
                  </TableHead>
                 <TableBody>
                    {filteredPayments.length > 0 ? (
                      filteredPayments.map((payment, index) => (
                        <TableRow key={payment.coachId}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>
                            {payment.coachName
                              .toLowerCase()
                              .split(' ')
                              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')}
                          </TableCell>
                        <TableCell>{payment.amount}</TableCell>
                          <TableCell>{payment.transationid}</TableCell>
                          <TableCell>{payment.paymentmode}</TableCell>
                          <TableCell>{payment.paymentDate}</TableCell>
                              <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                                 <Chip label={payment.paymentstatus === 1 ? 'Success' : 'Failed'} color={payment.paymentstatus === 1 ? 'success' : 'error'} />
                                               </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                         
                          <Box sx={{ mt: 2 }}>No Transaction Details found.</Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody> 
                </Table>
              </TableContainer>
    </MainCard>
  )
}

export default PaymentLogs;